import { CreateGuestComponent } from "./create-guest/create-guest.component";
import { EditGuestComponent } from "./edit-guest/edit-guest.component";
import { GuestListComponent } from "./guest-list/guest-list.component";
import { GuestViewComponent } from "./guest-view/guest-view.component";


export const GuestRouting = [
    { path: '', redirectTo: 'view-guest', pathMatch: 'full' },
    { path: 'add-guest', component: CreateGuestComponent },
    { path: 'view-guest', component: GuestListComponent },
    { path: 'single-view-guest/:guestID', component: GuestViewComponent },
    { path: 'edit-guest/:guestID', component: EditGuestComponent },
];

export const GuestRoutingBreadcrumbs = [
    { name: 'Single-view',path:'/single-view-guest' },
    { name: 'Edit', path: '/edit-guest' },
    { name: 'Add', path: '/add-guest' },

];